// 07:S15 (Kate): every open dialog locks the page behind it; stacked dialogs
// share one lock, and the page's own overflow and padding come back when the
// last one closes. The page keeps its scroll position, and the lock pads the
// page by the scrollbar it hides so nothing behind the dialog shifts.
let pageScrollLocks = 0;
let restorePageScroll: (() => void) | null = null;

export const lockPageScroll = () => {
  pageScrollLocks += 1;
  if (pageScrollLocks === 1) {
    const root = document.documentElement;
    const { overflow, paddingRight } = root.style;
    const scrollbar =
      root.clientWidth > 0 ? window.innerWidth - root.clientWidth : 0;
    if (scrollbar > 0) {
      const padding = parseFloat(getComputedStyle(root).paddingRight) || 0;
      root.style.paddingRight = `${padding + scrollbar}px`;
    }
    root.style.overflow = "hidden";
    restorePageScroll = () => {
      root.style.overflow = overflow;
      root.style.paddingRight = paddingRight;
    };
  }
  return () => {
    pageScrollLocks -= 1;
    if (pageScrollLocks === 0) {
      restorePageScroll?.();
      restorePageScroll = null;
    }
  };
};
